import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { LibraryUploadStep, MaterialPanelContext } from '../../../context/MaterialPanelContext';
import { useRefCallback } from '@tencent/glue-react-use';
import React, { useContext, useMemo, useState } from 'react';
import { noop } from '../../common/utils';
var initUploadDetail = {
  abort: noop,
  fileName: 'unknown',
  poster: ''
};
export var RcMaterialPanel = function RcMaterialPanel(_ref) {
  var children = _ref.children;
  var _useState = useState(LibraryUploadStep.CLOSE),
    _useState2 = _slicedToArray(_useState, 2),
    step = _useState2[0],
    setStepValue = _useState2[1];
  var _useState3 = useState(initUploadDetail),
    _useState4 = _slicedToArray(_useState3, 2),
    currentUploadFileDetail = _useState4[0],
    setCurrentUploadDetail = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    errMsg = _useState6[0],
    setErrMsg = _useState6[1];
  var setStep = useRefCallback(function (val) {
    if (val === LibraryUploadStep.CLOSE) {
      currentUploadFileDetail.abort();
    }
    setStepValue(val);
  });
  var materialValue = useMemo(function () {
    return {
      step: step,
      errMsg: errMsg,
      currentUploadFileDetail: currentUploadFileDetail,
      setStep: setStep,
      setErrMsg: setErrMsg,
      setCurrentUploadDetail: setCurrentUploadDetail
    };
  }, [step, errMsg, currentUploadFileDetail, setStep]);
  return React.createElement(MaterialPanelContext.Provider, {
    value: materialValue
  }, children);
};
export var useRcMaterialPanel = function useRcMaterialPanel() {
  var value = useContext(MaterialPanelContext);
  if (!value) {
    throw new Error('useRcMaterialPanel must under <MaterialPanelContext>');
  }
  return value;
};